import {FETCHED_PARTNERS_SUCCESSFULLY} from '../constants';

const initial_state = {
  partners: {}
}
const PartnerReducer = (state = initial_state, action) => {
  switch (action.type) {
    case FETCHED_PARTNERS_SUCCESSFULLY:
      return {...state, partners: {...action.payload}};
    default:
      return state;
  }
}
export default PartnerReducer;